import { createApp } from 'vue'
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
import _ from "lodash";
import moment from "moment";
import PageHeader from "@/components/PageHeader.vue";
import VueDaumPostcode from "vue-daum-postcode";
import StoragePlugin from 'vue-web-storage';
import VueDayjs from 'vue3-dayjs-plugin'
import {vfmPlugin} from "vue-final-modal";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import SimpleVueValidator from 'simple-vue3-validator'
import 'element-plus/dist/index.css'
import  QuillEditor  from 'vue3-quill-editor-vite'
import 'vue3-quill-editor-vite/dist/style.css'

import VueWordCloud from 'vuewordcloud';

window.global = window;
import ElementPlus from 'element-plus'
import 'dayjs/locale/ko';
import Api from "@/api/index";
let app = createApp(App);
import ko from "element-plus/dist/locale/ko"
import $ from "jquery";
window.$ = $

app.use(QuillEditor)
app.use(store);
app.use(router)
app.use(vfmPlugin)
app.use(SimpleVueValidator)
app.use(VueDaumPostcode)
app.use(VueWordCloud)
app.use(StoragePlugin, {
  prefix:  'com.hamalab.prone-vue-admin',
  drivers: ['local'],
})



app.config.globalProperties.$api = Api;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$_ = _;
app.use(ElementPlus, {
  locale: ko
})
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(VueDayjs)
app.component('page-header', PageHeader)
app.component('vue-word-cloud', VueWordCloud)
app.use(store)
app.mount('#app')
